var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomization(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "#77C002",
    fillOpacity: 0.095
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#customization_svg__clip0_1144_24208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 22.701H14.355v41.045H71V22.701z",
    fill: "#6DA512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.727 37.88H40.543v25.866h13.184V37.88z",
    fill: "#497700",
    fillOpacity: 0.977
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.725 37.88h-9.49v25.866h9.49V37.88z",
    fill: "#6DA512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 22.701H57.05v41.045H71V22.701z",
    fill: "#497700",
    fillOpacity: 0.977
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.996 33.777H16.985a.254.254 0 01-.255-.255v-5.951c0-.14.114-.255.255-.255h36.01c.142 0 .255.114.255.255v5.951c0 .14-.113.255-.254.255z",
    fill: "#F8FCF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.385 56.217v4.98H17.039v-4.98h21.346zm.313-.313H16.727v5.606h21.97v-5.606zM53.414 56.217v4.98h-7.32v-4.98h7.32zm.312-.313h-7.945v5.606h7.945v-5.606z",
    fill: "#497700",
    fillOpacity: 0.977
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.447 54.11H16.985a.254.254 0 01-.255-.255V37.762h21.972v16.093c0 .141-.114.255-.255.255z",
    fill: "#F8FCF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.348 53.9l11.43-15.93H38.492v3.667L29.997 53.9H19.348z",
    fill: "#FCFCFC",
    stroke: "#FCFCFC",
    strokeWidth: 0.417
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 31.691L57.05 49.665v14.081H71V31.691z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.722 38.746h-7.945v15.206h7.945V38.746z",
    fill: "#F8FCF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.515 38.09v7.512l-5.214 8.116h-2.315v-6.826l5.856-8.803h1.673z",
    fill: "#FCFCFC",
    stroke: "#FCFCFC",
    strokeWidth: 0.417
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.727 37.88H40.543v.866h13.184v-.865z",
    fill: "#497700",
    fillOpacity: 0.977
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.947 32L57.05 49.053v-.465l10.69-13.12-10.69 11.797v-.438l13.672-15.021a.147.147 0 01.205-.01c.06.05.069.141.019.203z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.99 42l.001 1.914a1.831 1.831 0 11-3.664 0 1.832 1.832 0 01-3.665 0 1.832 1.832 0 11-3.665 0 1.831 1.831 0 11-3.664 0 1.832 1.832 0 01-3.665 0c0 1.012-.82 1.832-1.832 1.832A1.832 1.832 0 0113 43.913v-1.914l3.73-4.24h21.971L34.991 42z",
    fill: "#497700",
    fillOpacity: 0.977
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 20.256H14.355V22.7H71v-2.445z",
    fill: "#F8FCF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 20.256H57.05V22.7H71v-2.445z",
    fill: "#6DA512"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "customization_svg__clip0_1144_24208"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13 20.256)",
    d: "M0 0h58v43.49H0z"
  })))));
}
export default SvgCustomization;